import Button from './basic/Button';
import ButtonAnchor from './basic/ButtonAnchor';

const Home = () => {

  return (

    <main>

      <section className="hero">

        <div className="hero-crop">
          <img src="/images/header/new/new_banner_squiggly.png" alt="Header Image" />
        </div>

        <div className="translucent">
          <div className="content">
            <h3>Hi, I'm Lucy</h3>
            <h2>Hobbyist Software Developer and Game Designer</h2>
            <p>All around giant computer nerd. I make various different types of gaming and software projects, many of which are showcased on this website. Follow me on <a href="https://bsky.app/profile/minibonzo.bsky.social" target="_blank">Bluesky!</a></p>
            <ButtonAnchor to="#my-projects" text="See my projects" icon_path="/images/icons/down-icon.svg" alt_text="Down Arrow" target="" />
          </div>
        </div>

      </section>

      <section className="articles" id="my-projects">

        <div className="column" id="left-column">

          <article>

            <img src="/images/homepage/new_app_icons.png" alt="App Icons" />

            <h3>My Mobile Games</h3>

            <p>
              From October 2021 to April 2024, I learnt how to make mobile games using Microsoft C# and the Unity Game Engine and I published them on the Apple App Store and Google Play Store. It is a project which combines graphic design and programming to create a product that people can play and enjoy.
              <br /><br />
              I have released mobile 9 games, Rolling Rush, Plank Spin, Bouncy Bird, Fruit Sort, Merge Coin, Mountain Rush, Leaf Buster, Juggle Tap and my latest game, Road Riches (incredible names I know). This was my main project for 2.5 years, I have spent almost 1000 hours on it. I am now moving on to other projects, possibly making a bigger indie game for Steam at some point.
              <br /><br />
              One of my best games is my 7th release, Leaf Buster, a game where you tap falling leaves to destroy, stopping them from hitting the bottom of the screen for as long as possible. There are a variety of difficulties and themes to play around with, and your tapping power, defence and gravity can be upgraded to allow you to secure higher scores for a greater success ranking, though I am most proud of my graphics.
            </p>

            <Button to="/games" text="Go To My Games" icon_path="/images/icons/games-icon.svg" alt_text="Controller" />

          </article>

          <article  class="no-image" id="privacy-policy">

            <div className="content">

              <h3>Privacy Policy</h3>

              <p>
                No personal data is collected by myself or the ad provider in any games published under the name "Jonah Heywood"
              </p>

            </div>

          </article>

        </div>

        <div className="column" id="right-column">

          <article>

            <img src="/images/homepage/new_mod_blocks.png" alt="Pixel Art" className="pixel-art" />

            <h3>Lucy's Mod</h3>

            <p>
              Lucy's Mod is the mod I made for Minecraft 1.20.2, using Fabric. It adds a new purple wood type, a new stone block called Pearlstone, new ores, Chromium and Bonzite and new decorative blocks the Big Making Table and the Toolstation. There are also new tools and armour pieces made from Chromium, each of which can be upgraded using Pearls to boost their stats, and new tools and armour pieces made from Bonzite, which can be crafted by upgrading the final form of their Chromium equivalent using a Bonzite Upgrade smithing template.
              <br /><br />
              It isn't completely perfect, but below you can download the first public version, which should work well for Creative Mode, and I plan on making a guide for Survival Mode, giving hints about where new things can be found and new crafting recipes. I also might upload this to CurseForge in the future, but this isn't a priority at the moment.
            </p>

            <Button to="/lucymod" text="Download the Mod" icon_path="/images/icons/mod-icon.svg" alt_text="Cube" />

          </article>

          <article class="no-image">

            <h3>Web Toys</h3>

            <p>
              I occasionally make simple web toys, often to fulfil a niche purpose (such as the Random Byte Generator) and put them here. Many may have interesting bugs. The Tempo Finder lets you tap a beat with your spacebar, and it will tell you the tempo in BPM (Beats per minute). The Random Byte Generator creates a pseudo-random string of 8 binary digits (0s and 1s), I don't know why you would want it but it exists. Click the link below to view them.
            </p>

            <Button to="/toys" text="Go To Web Toys" icon_path="/images/icons/toys-icon.svg" alt_text="Cards" />

          </article>

        </div>

      </section>
      

    </main>

  );
}

export default Home;